import { useState } from "react";
import { InputProps } from "../../../types/product";
import { inputBase } from "../../../constants/product";

export default function Input({ value, onChange, placeholder, maxLength, type = "text" }: InputProps) {
    const [focused, setFocused] = useState(false);
    return (
        <div style={{ position: "relative" }}>
            <input
                type={type}
                value={value} onChange={onChange} placeholder={placeholder} maxLength={maxLength}
                style={{
                    ...inputBase,
                    paddingRight: maxLength ? 52 : 14,
                    borderColor: focused ? "var(--or)" : "var(--border)",
                    boxShadow: focused ? "0 0 0 3px rgba(191,61,12,0.10)" : "none",
                }}
                onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
            />
            {maxLength && (
                <span style={{
                    position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                    fontSize: 11, color: value.length > maxLength * 0.85 ? "var(--or)" : "var(--text3)",
                    pointerEvents: "none",
                }}>
                    {value.length}/{maxLength}
                </span>
            )}
        </div>
    );
}
